import React from 'react';
import { useDeviceType } from '@hotelplan/libs.context.device-type';
import { ESearchType } from 'fdr/components/candidate/fdr-search-control/destination/fdr-destination-field.types';
import { useFdrResetFiltersForm } from 'fdr/components/candidate/fdr-search/filters/use-fdr-reset-filters-form';
import { IFdrFiltersFormState } from 'fdr/components/candidate/fdr-search/types/filters.types';

export const useFilterFormActions = <TState>(
  setState: (
    nextState: React.SetStateAction<TState>,
    cb?: (nextState: TState) => void
  ) => void,
  postSubmit?: (state: TState) => void
) => {
  const { mobile } = useDeviceType();
  const { resetHandler } = useFdrResetFiltersForm(ESearchType.WISHLIST);

  const onSubmit = (formState: IFdrFiltersFormState): void => {
    setState(
      prev => ({
        ...prev,
        filters: mobile ? { ...formState, prevChangedFilter: null } : formState,
      }),
      postSubmit
    );
  };

  return {
    onSubmit,
    onReset: resetHandler,
  };
};
